import Button from 'components/field/Button';
import Icon from 'components/global/Icon';
import Tooltip from 'components/global/Tooltip';
import Typography from 'components/global/Typography';

import { faClock, faXmark } from '@fortawesome/pro-solid-svg-icons';

import * as S from './styled/MinimizeButton.styled';

const MinimizeButton = ({ onShow, onClose, label, tooltip = '', icon = faClock, iconColor = 'var(--yellow)' }) => (
	<Tooltip placement="top" title={tooltip}>
		<S.StyledAlert variant="warning" onClick={onShow}>
			<Icon icon={icon} color={iconColor} />

			<Typography color="var(--alert-description)" fontWeight="500">
				{label}
			</Typography>

			<Button
				variant="transparent"
				color="var(--alert-description)"
				iconButton
				icon={faXmark}
				size="small"
				onClick={(e) => {
					e.preventDefault();
					e.stopPropagation();
					onClose();
				}}
			/>
		</S.StyledAlert>
	</Tooltip>
);

export default MinimizeButton;
